import type { ReactNode } from 'react'

// Inline stroke icons in the dashboard's existing style (currentColor, ~1.5 stroke,
// round caps/joins) — no emoji, no icon library. viewBox is a 20×20 grid.
const PATHS: Record<string, ReactNode> = {
  // Impact — blast-radius ripples around an epicentre.
  impact: (
    <>
      <circle cx="10" cy="10" r="2" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="5.5" />
      <circle cx="10" cy="10" r="8.5" opacity="0.45" />
    </>
  ),
  // Root cause — magnifier.
  search: (
    <>
      <circle cx="8.5" cy="8.5" r="5.5" />
      <line x1="12.8" y1="12.8" x2="17.5" y2="17.5" />
    </>
  ),
  // Proposed fix — wrench.
  fix: (
    <path d="M14.8 6.1a3.4 3.4 0 0 1-4.4 4.4l-4.7 4.7a1.6 1.6 0 0 1-2.3-2.3l4.7-4.7a3.4 3.4 0 0 1 4.4-4.4l-2.1 2.1 1.6 1.6 2.8-1.4z" />
  ),
  // Investigation journey — route between two waypoints.
  journey: (
    <>
      <circle cx="5" cy="15" r="1.8" />
      <circle cx="15" cy="5" r="1.8" />
      <path d="M6.3 13.7 13.7 6.3" strokeDasharray="2 2.4" />
    </>
  ),
  // Source file tab.
  file: (
    <>
      <path d="M5.5 2.8h5l4 4V16.7a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5V3.3a.5.5 0 0 1 .5-.5z" />
      <path d="M10.5 2.8V6.8h4" />
    </>
  ),
  // Test file tab — beaker.
  test: (
    <>
      <path d="M8 3v4.5L4.6 14.6a1 1 0 0 0 .9 1.5h9a1 1 0 0 0 .9-1.5L12 7.5V3" />
      <line x1="7" y1="3" x2="13" y2="3" />
    </>
  ),
}

export default function SectionIcon({
  name,
  size = 20,
  color = 'var(--accent-light)',
}: {
  name: keyof typeof PATHS | string
  size?: number
  color?: string
}) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', color, flexShrink: 0 }} aria-hidden>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {PATHS[name] ?? PATHS.search}
      </svg>
    </span>
  )
}
